import type { ProductKey, WorkspaceSummary } from './contracts';

const featureAliases: Partial<Record<ProductKey, string[]>> = {
  planner: ['planner', 'social_planner'],
  chatbot: ['chatbot'],
  ai: ['ai', 'ai_assistant'],
};

export interface FeatureAccess {
  enabled: boolean;
  mode: string;
  message?: string;
}

export function getFeatureAccess(workspace: WorkspaceSummary | undefined, product: ProductKey): FeatureAccess {
  const entitlements = workspace?.entitlements;
  if (!entitlements) return { enabled: true, mode: 'on' };

  for (const key of featureAliases[product] || [product]) {
    const state = entitlements.feature_state?.[key];
    if (!state) continue;
    const mode = state.mode || (state.enabled === false ? 'off' : 'on');
    return { enabled: state.enabled !== false && mode === 'on', mode, message: state.message };
  }

  for (const key of featureAliases[product] || [product]) {
    const direct = entitlements.features?.[key];
    if (typeof direct === 'boolean') return { enabled: direct, mode: direct ? 'on' : 'off' };
    const subscribed = entitlements.subscription?.features?.[key];
    if (typeof subscribed === 'boolean') return { enabled: subscribed, mode: subscribed ? 'on' : 'off' };
  }

  const explicitProduct = entitlements.products?.[product];
  if (typeof explicitProduct === 'boolean') return { enabled: explicitProduct, mode: explicitProduct ? 'on' : 'off' };

  const scope = entitlements.subscription?.product_scope;
  if (scope) {
    const enabled = scope === 'bundle' || scope === product;
    return { enabled, mode: enabled ? 'on' : 'off' };
  }
  return { enabled: true, mode: 'on' };
}
